import React, { useRef } from "react";
import {
  Table,
  Carousel,
  Image,
} from "antd";
import ComponentTitle from "../../../Common/ComponentTitle";
import { useLocation } from "react-router-dom";
import { FaBath, FaBed, FaLocationDot } from "react-icons/fa6";
import {  MdDashboard } from "react-icons/md";
import { FaParking } from "react-icons/fa";
import InnerHTML from 'dangerously-set-html-content'
const ShowPlot = () => {
  const location = useLocation();
  const record = location.state?.record;
  const contentStyle = {
    margin: 0,
    // height: "460px",
    width: "100%",
    color: "#fff",
    lineHeight: "160px",
    textAlign: "center",
    background: "#364d79",
  };
  const onChange = (currentSlide) => {
    console.log(currentSlide);
  };
  console.log(record, "record");
  const columnsModal = [
    {
      // title: "Information Type",
      dataIndex: "field",
      key: "field",
    },
    {
      // title: "Value",
      dataIndex: "value",
      key: "value",
    },
  ];

  const fields = [
    { key: "1", label: "Lease Type", value: record.leaseType },
    { key: "2", label: "Furnish", value: record.furnishing },
    { key: "3", label: "Floor No.", value: record.floorNo },
    {
      key: "4",
      label: "Carpet Area",
      value: `${record.carpetArea}${record.carpetAreaUnit}`,
    },
    { key: "5", label: "Location", value: record.location },
    { key: "7", label: "Price", value: ` ₹.${record.price}` },
    { key: "8", label: "Project", value: record.projectName },
    { key: "9", label: "State", value: record.state },
    { key: "10", label: "Total Floors", value: record.totalFloors },
    { key: "11", label: "Type", value: record.type },
    { key: "12", label: "ZipCode", value: record.zipCode },
    {
      key: "13",
      label: "Bachelors",
      value:
        record.bachelorsAllowed === true
          ? "Bachelors Allowed"
          : "Bachelors Not allowed",
    },
  ];

  const data = fields.map((field) => ({
    key: field.key,
    field: (
      <p className="font-bold text-rgbaprimary9 font-poppins">{field.label}</p>
    ),
    value: <p className=" font-poppins">{field.value}</p>,
  }));

  return (
    <div>
      <ComponentTitle title={"Properties Details"} />
      <div className="grid grid-cols-1 md:grid-cols-[65%_35%] gap-4  w-auto">
        <div className="bg-white p-4">
          <Carousel
            autoplay={true}
            afterChange={onChange}
            className="shadow-[0px_10px_25px_0px_rgba(0,0,0,0.3)]"
          >
            {record.images.map((i, id) => {
              return (
                <div key={id}>
                  <Image
                    style={{
                      width: "100%",
                      height: "300px",
                      objectFit: "contain",
                    }}
                    src={`${process.env.REACT_APP_IMAGE_URL}${i.imagePath}`}
                    preview={false}
                  />
                </div>
              );
            })}
          </Carousel>

          <div>
            <div className="font-bold font-poppins text-lg text-rgbaprimary9 mt-4">
              {" "}
              {record.price} ₹
            </div>
            <div className="font-bold text-lg font-poppins mt-3 opacity-45">
              {" "}
              {record.title}
            </div>
            <div className="text-sm font-inter mt-4">  <InnerHTML html= {record.description} /></div>
            <div className="font-inter mt-8 flex">
              <FaLocationDot className="text-rgbaprimary9" /> {record.address}
            </div>
            <div className="font-inter mt-4  bg-[#edf2f9] p-4 grid grid-cols-1 sm:grid-cols-4">
              <div className="flex gap-2">
                <MdDashboard className="text-rgbaprimary9" />
                {record.plotArea} {record.plotAreaUnit}
              </div>
              <div className="flex gap-2">
                {" "}
                <FaBed className="text-rgbaprimary9" />
                {record.bedrooms}
              </div>
              <div className="flex gap-2">
                <FaBath className="text-rgbaprimary9" />
                {record.bathrooms ?? "--"}
              </div>{" "}
              <div className="flex gap-2">
                <FaParking className="text-rgbaprimary9" />
                {record.parking ?? "--"}
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div className="bg-white p-2 overflow-scroll h-full">
          {" "}
          <p className="m-4 text-rgbaprimary9 font-bold text-lg font-poppins">
            Description
          </p>
          <Table
            columns={columnsModal}
            dataSource={data}
            pagination={false}
            bordered
            size="small"
            rowClassName="table-row"
          />
        </div>
      </div>
    </div>
  );
};

export default ShowPlot;
